// =============================== 获取隐藏标签================
//   获取token节点
//   let the_token=$("#scriptClass").attr("data-token");
  var fileref;
  fileref = document.createElement('link');
  fileref.setAttribute("rel", "stylesheet");
  fileref.setAttribute("type", "text/css");
  fileref.setAttribute("href", "https://www.omnipersonalizer.com/pages/info.css?shop="+window.location.host);
  document.getElementsByTagName("head")[0].appendChild(fileref);
  
//document.write('<link rel="stylesheet" href="info.css">')
/*获取文字*/
var languages = {}
$.ajax({
  type: "get",
  url: "https://www.omnipersonalizer.com/omniBizifyPublic/manage/language/get?language=en_US",
  async: false,
  success: function(response) {
    languages = response
  }
});
let enableStatus = [];
$.ajax({
  type: "get",
  url: "https://www.omnipersonalizer.com/omniBizifyPublic/front/showSet/getEnable",
  async: false,
  success: function(response) {
    enableStatus = response
    console.log(response)
  }
});

    
 // ================================ 折扣后的数据 ================================================
    // 商品折扣后数据
  var afterDiscount = {
	"cartOrderVariantVos": [],
	"customerIdShop": 0,
  "totalDiscount": "",
  "properties": {}
  }
    // cart 获取
  var getCartInfo = []
  var getCustomInfo = []
  // =================================== 购物车接口 ==========================
    $.ajax({  
    type : "get",  
    url : "https://"+window.location.host+"/cart.js",  
    dataType:"text",
    async : false,
    success : function(data){  
      let total =  JSON.parse(data);
      console.log(total)
      getCustomInfo = total.items
      if(total.items) {
        total.items.map(items =>{
          getCartInfo.push({
            "currentPrice": null,
            "discountAmount": null,
            "finalPrice": items.final_price,
            "originalPrice": items.original_price,
            "quantity": items.quantity,
            "productIdShop": items.product_id,
            "variantIdShop": items.variant_id,
            "key": items.key,
            "properties":items.properties
          })
        })
      }
    },
    error: function(err){
      alert("error")
    }
  })
  
   // 获取页面信息  
  getCart()
  function getCart() {
// =====================================自定义====================================
//         conALL=[];
//         getCustomInfo.map((tokes,index)=>{
//           $(".cart-drawer__content .cart-drawer__item").eq(index).find(".ajaxcart_url").remove();
//           if(!tokes.properties){return;}
//           if(tokes.properties.token){
//           	$.ajax({  
//             type : "get",  
//             url : "https://www.omnipersonalizer.com/personality/front/customerDesignOrder/getByToken?token="+tokes.properties.token,  
//             dataType:"text",
//             async : false,
//             success : function(suc){
//               let con='';
//           con+='<li class=" suf-pro product-details__item product-details__item--property" data-cart-item-property>';
//               JSON.parse(suc).map((surface,surindex)=>{
//                 con+='<div class="sufFather faceIconCart">'+
//                   ' <p class="suf" style="font-size:13px;"><span class="blod">+</span>'+surface.surfaceName+''+languages.customizationInfo+'</p>'+
//                    '</div>'; 
//                  con+='<div class="hide suf-pro faceProCart">'+
//                 '<div class="lookImg mt10 flex flex_center lookIconCart">'+
//                 '<img  style="width:50px;" src="https://www.omnipersonalizer.com'+surface.finalImage+'">'+
//                 '<span class="btnSpan" data-cart-item-property-value>'+languages.look+'</span>'+
//                   '</div>'+
//                 '<div class="model hide">'+
//                 '<div class="showPic3 pic3Icon"><img class="mt50" src="https://www.omnipersonalizer.com'+surface.finalImage +'" style="width:90%;"></a></div>'+
//               '</div>'+
//               '</div>'
//               });
//               con+='<li>';
//               conALL.push(con)
//               $(".cart tbody .cart__row").eq(index).find("a").each(function(){
//                 if($(this).text() == "Remove" ) {
//                 	$(this).before("<ul class='ajaxcart_url ajaxcart__product-meta' style='margin:0;list-style: none;padding:0;'>"+con+"</ul>");
//                 }
//               })
//             }
//           });
//         }
//       });
    // ======================================= 折扣价格===================================================
    $.ajax({
      type: "post",
      url: "https://www.omnipersonalizer.com/omniBizifyPublic/front/cartDiscount/getDiscount",
      data: JSON.stringify(getCartInfo),
      contentType: "application/json",
      dataType: "text",
      async: false,
      success: function(response) {
//         开启折扣
        
          afterDiscount.cartOrderVariantVos = [];
          console.log(response)
          let variantDiscountVos = JSON.parse(response).variantDiscountVos;
          if(variantDiscountVos) {
              variantDiscountVos.map((getCon,i) =>{
                if(enableStatus.enableDiscount) {
                    //"================提示不满足折扣（如果开启折扣）=======================
                    $(".cart__cell--quantity span").remove()
                    //input框
                    $(".cart tbody .cart__row").eq(i).find(".cart__cell--quantity").html(`
                        <div class="js-qty">
                        <input type="text" value="${getCon.quantity}" id="${getCon.key}"  pattern="[0-9]*" data-line="1" class="js-qty__input" aria-live="polite">
                        <button type="button" class="js-qty__adjust js-qty__adjust--minus" aria-label="Reduce item quantity by one">
                          <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-minus" viewBox="0 0 22 3"><path fill="#000" d="M21.5.5v2H.5v-2z" fill-rule="evenodd"></path></svg>

                        </button>
                        <button type="button" class="js-qty__adjust js-qty__adjust--plus" aria-label="Increase item quantity by one">
                          <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" viewBox="0 0 22 21"><path d="M12 11.5h9.5v-2H12V0h-2v9.5H.5v2H10V21h2v-9.5z" fill="#000" fill-rule="evenodd"></path></svg>
                        </button>
                      </div>
                  `)

                    //================单条总价格=======================
                    $(".cart tbody .cart__row").eq(i).find(".cart__cell--total").html(`
                    <div class="${getCon.discount ? 'hide' : ''}">${getCon.originalTotal}</div>
                    <div class="${getCon.discount ? '' : 'hide'}">
                    <s>${getCon.originalTotal}</s>
                    <p class="order-discount">${getCon.total}</p>
                    </div>
                    `)
                }
                let cartVos= {
                  "quantity":getCon.quantity,
                  "productShopId": getCon.productIdShop,
                  "variantIdShop": getCon.variantIdShop,
                  "properties":getCon.properties
                }
                afterDiscount.cartOrderVariantVos.push(cartVos)

              console.log(getCon,9191929292922)
              })
              console.log("================提交按钮，开启折扣或者最小起订量=======================")
              if(enableStatus.enableDiscount || enableStatus.enableMoq) {
                $("button[name='checkout']").addClass('hide')
                $(".controlsSubmitCart").remove()
                $("button[name='checkout']").before(`<div class="controlsSubmitCart" name="checkOut" style="border: 1px solid currentColor;
                  padding: 12px 20px;
                  line-height: 1.42;
                  font-weight: bold;
                  background-color: #2d4f1e;
                  display:inline-block;
                  width: 140px;
                  text-align: center;
                  float: right;
                  margin-left: 10px;
                  color: #fff;" value="">Check out</div>`)
              }
              console.log("======s==========商品折扣后数据==============s=========")
              afterDiscount.customerIdShop = ""
              if(__st.cid) {
                afterDiscount.customerIdShop = __st.cid
              } 
              afterDiscount.totalDiscount = JSON.parse(response).totalDiscount
            }
//         if(enableStatus.enableDiscount) {
//           afterDiscount.cartOrderVariantVos = [];
//           console.log(response)
//           let variantDiscountVos = JSON.parse(response).variantDiscountVos;
//           if(variantDiscountVos) {
//               variantDiscountVos.map((getCon,i) =>{
//                   //"================提示不满足=======================
//                   $(".cart__cell--quantity span").remove()
//                   //input框
//                   $(".cart tbody .cart__row").eq(i).find(".cart__cell--quantity").html(`
//                       <div class="js-qty">
//                       <input type="text" value="${getCon.quantity}" id="${getCon.key}"  pattern="[0-9]*" data-line="1" class="js-qty__input" aria-live="polite">
//                       <button type="button" class="js-qty__adjust js-qty__adjust--minus" aria-label="Reduce item quantity by one">
//                         <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-minus" viewBox="0 0 22 3"><path fill="#000" d="M21.5.5v2H.5v-2z" fill-rule="evenodd"></path></svg>

//                       </button>
//                       <button type="button" class="js-qty__adjust js-qty__adjust--plus" aria-label="Increase item quantity by one">
//                         <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" viewBox="0 0 22 21"><path d="M12 11.5h9.5v-2H12V0h-2v9.5H.5v2H10V21h2v-9.5z" fill="#000" fill-rule="evenodd"></path></svg>
//                       </button>
//                     </div>
//                 `)

//                   //================单条总价格=======================
//                   $(".cart tbody .cart__row").eq(i).find(".cart__cell--total").html(`
//                   <div class="${getCon.discount ? 'hide' : ''}">${getCon.originalTotal}</div>
//                   <div class="${getCon.discount ? '' : 'hide'}">
//                   <s>${getCon.originalTotal}</s>
//                   <p class="order-discount">${getCon.total}</p>
//                   </div>
//                   `)
//                 let cartVos= {
//                   "quantity":getCon.quantity,
//                   "productShopId": getCon.productIdShop,
//                   "variantIdShop": getCon.variantIdShop,
//                   "properties":getCon.properties
//                 }
//                 afterDiscount.cartOrderVariantVos.push(cartVos)

//               })
//               console.log("================提交按钮=======================")
//               $("button[name='checkout']").addClass('hide')
//               $(".controlsSubmitCart").remove()
//               $("button[name='checkout']").before(`<div class="controlsSubmitCart" name="checkOut" style="border: 1px solid currentColor;
//                 padding: 12px 20px;
//                 line-height: 1.42;
//                 font-weight: bold;
//                 background-color: #2d4f1e;
//                 display:inline-block;
//                 width: 140px;
//                 text-align: center;
//                 float: right;
//                 margin-left: 10px;
//                 color: #fff;" value="">Check out</div>`)

//               console.log("======s==========商品折扣后数据==============s=========")
//               afterDiscount.customerIdShop = ""
//               if(__st.cid) {
//                 afterDiscount.customerIdShop = __st.cid
//               } 
//               afterDiscount.totalDiscount = JSON.parse(response).totalDiscount
//             }
//           }

        //         开启最小起订量
//         if(enableStatus.enableMoq) {
//             console.log("================总价格=======================")
//             $("#CartSubtotal").html(`${JSON.parse(response).totalCurrentPrice}`)
//   //           $(".cart__subtotal-wrapper").html(` <div style="width: 100%;"><h3 class="cart-drawer__subtotal" style="display: inline-block;float:left;">Subtotal</h3><span style="float:right;font-weight: bold;">${JSON.parse(response).totalCurrentPrice}</span></div>`)
//             //================提交按钮=======================
//             $("button[name='checkout']").addClass('hide')
//             $(".controlsSubmitCart").remove()
//             $("button[name='checkout']").before(`<div class="controlsSubmitCart" name="checkOut" style="
//               display: inline-block;
//               width: auto;
//               text-decoration: none;
//               text-align: center;
//               vertical-align: middle;
//               white-space: nowrap;
//               cursor: pointer;
//               border: 1px solid transparent;appearance: none;
//               background-color: #006eff;
//               color: #fff;font-size: 0.8125em;
//               font-weight: 700;
//               letter-spacing: 0.15em;
//               text-transform: uppercase;
//               padding: 15px 45px;
//               transition: color 0.1s ease-in,background-color 0.1s ease-in;
//             ">Check out</div>`)

//             //======s==========商品折扣后数据==============s=========
//             afterDiscount.customerIdShop = ""
//             if(__st.cid) {
//               afterDiscount.customerIdShop = __st.cid
//             } 
//             afterDiscount.totalDiscount = JSON.parse(response).totalDiscount
//             let cartVos= {
//               "quantity":JSON.parse(response).quantity,
//               "productShopId": JSON.parse(response).productIdShop,
//               "variantIdShop": JSON.parse(response).variantIdShop,
//               "properties":JSON.parse(response).properties
//             }
//             afterDiscount.cartOrderVariantVos.push(cartVos)
//             console.log(11827187182,JSON.parse(response), cartVos)
//           }
      },
      error: function(err) {
        console.log(err)
      }
    });
  
  }
	//更改数量
  var myVar;
//   更改数量
$(document).on("blur",".js-qty__input",function() {
  let that= this,sGetVal = $(that).val();
  console.log(that.getAttribute("id"))
  $(".cart .cart__row").each(function(eq) {
    if($(this).find($(".js-qty__input")).attr("id") == that.getAttribute("id")) {
      console.log($(this).find($(".js-qty__input")).attr("id") == that.getAttribute("id"),that.getAttribute("id"))
      getCartInfo[eq-1].quantity = sGetVal
      getCart()
    }
   })
})
//加减
$(document).on("click",".js-qty__adjust--plus",function() {
  let that= this,sGetVal = Number($(that).siblings(".js-qty__input").val()) + 1;
  $(".cart .cart__row").each(function(eq) {
    if($(this).find($(".js-qty__input")).attr("id") == $(that).siblings(".js-qty__input").attr("id")) {
      getCartInfo[eq-1].quantity = sGetVal
      getCart()
    }
  })
})
$(document).on("click",".js-qty__adjust--minus",function() {
  let that= this,sGetVal = $(that).siblings(".js-qty__input").val();
  if(sGetVal<= 1) {
  	sGetVal = 1
  } else {
    sGetVal = Number($(that).siblings(".js-qty__input").val()) - 1
  }
  $(".cart .cart__row").each(function(eq) {
    if($(this).find($(".js-qty__input")).attr("id") == $(that).siblings(".js-qty__input").attr("id")) {
      getCartInfo[eq-1].quantity = sGetVal
      getCart()
    }
  })
})

  // 结算
  $(document).on("click",".controlsSubmitCart",function() {
    console.log(JSON.stringify(afterDiscount))
    $.ajax({
        type: "post",
        url: "https://www.omnipersonalizer.com/omniBizifyPublic/front/cartDiscount/addDraftOrder",
        data: JSON.stringify(afterDiscount),
        contentType: "application/json",
        dataType: "text",
        async: false,
        success: function(response) {
          if(JSON.parse(response).success) {
            window.location.href = JSON.parse(response).url
          } else {
            $(".cart__cell--quantity span").remove()
            // 判断是否符合要求
            JSON.parse(response).orderResultVariantVos.map((getMinNum,minI) =>{
              if(getMinNum.variantIdShop == afterDiscount.cartOrderVariantVos[minI].variantIdShop) {
                if(!getMinNum.moqCondition){
                  console.log(minI)
                  $(".responsive-table__row").eq(minI).find(".js-qty").before(`<span style="font-size:;12px;color:red;display:block;">${getMinNum.message}</span>`)
                }
              }
            })
          }
//           console.log(response)
//           console.log(JSON.parse(response).success)
          $('.errorTips').remove()
        },
        error: function(err) {
            $(".controlsSubmitCart").after(`<p class="mt20 errorTips"
              style="font-size:14px;
              width: 100%;
              display: block;
              overflow: hidden;
              text-align: left;
              padding-top: 20px;
              color: #006eff;">
              The shopping cart system is currently undergoing technical updates. Please reach out to us for assistance with checking out.
            </p>`)
          
          // console.log(err)
        }
      });
    
  });
// 展开
      $(document).on("click",".faceIconCart",function(){
        $(this).next(".faceProCart").toggleClass("hide")
          if($(this).children().children(".blod").text()=="+"){
            $(this).children().children(".blod").text("-")
          } else {
            $(this).children().children(".blod").text("+")
          }
      })
     //查看图片
    $(document).on("click",".lookIconCart",function(){
      if($(window).width()>800){
        $(".pic3Icon").css({"position":"fixed","top":$(window).scrollTop(),"left":0,"right":0,"margin":"0 auto","text-align":"center","max-width":"500px","padding":"20px 0"})
      } else{
      	$(".pic3Icon").css({"position":"fixed","top":"4%","left":0,"right":0,"margin":"0 auto","text-align":"center","max-width":"500px","padding":"20px 0"})
      }
      $(this).next(".model").removeClass("hide")
    })
    //隐藏图片
    $(document).on("click",".model",function(){
      $(this).addClass("hide")
    })
    